import React from "react";

import Typo from "Trackalyze/Typo";
import { useTranslation } from "react-i18next";
import { getNestedValue } from "~/js/utilities/getNestedValue";
import { GPXDATA_KEYVALUES_MAPPING } from "~/js/config/GPXMapping";
import Flex from "Trackalyze/Flex";
import Icon from "Trackalyze/Icon";
import { ListItem } from "Trackalyze/List";

const ItemGroup = (props) => {
  const { t } = useTranslation();

  const dataInfo = getNestedValue(
    GPXDATA_KEYVALUES_MAPPING,
    props.id,
    props.id,
  );
  return (
    <div
      id={props.id}
      data-gpx-outline={props.id}
      data-gpx-type={props.id}
      className="scroll-snap_item"
    >
      <ListItem
        leading={<Icon size="l" symbol={dataInfo.symbol} />}
        label={t(dataInfo.label)}
        className="gpx_icon"
      />

      <Flex spacing="3" vertical className="statistics_items">
        {props.children}
      </Flex>
    </div>
  );
};

export default ItemGroup;
